// 충돌 검사 관련 유틸리티 함수들
class CollisionUtils {
  // 원형 콜라이더 충돌 검사
  static checkCircularCollision(pos1, pos2, radius1, radius2) {
    const distance = pos1.distanceTo(pos2);
    return distance < radius1 + radius2;
  }

  // 환경 오브젝트와의 충돌 검사
  static checkEnvironmentCollision(
    position,
    environmentObjects,
    colliderRadius
  ) {
    for (const obj of environmentObjects) {
      // 나무와 돌만 충돌 검사 (풀은 제외)
      if (
        obj.userData.objectType === "big" ||
        obj.userData.objectType === "medium"
      ) {
        const distance = position.distanceTo(obj.position);

        // 오브젝트 타입에 따른 콜라이더 반지름 설정
        let objectRadius;
        if (obj.userData.objectType === "big") {
          objectRadius = 0.8; // 나무 콜라이더 반지름
        } else if (obj.userData.objectType === "medium") {
          objectRadius = 0.6; // 돌 콜라이더 반지름
        }

        // 충돌 검사 (원형 콜라이더 간 거리 비교)
        if (distance < colliderRadius + objectRadius) {
          return true; // 충돌 발생
        }
      }
    }
    return false; // 충돌 없음
  }

  // 안전한 위치로 이동
  static moveToSafePosition(
    currentPosition,
    targetPosition,
    environmentObjects,
    colliderRadius
  ) {
    // 환경 충돌 검사
    if (
      !this.checkEnvironmentCollision(
        targetPosition,
        environmentObjects,
        colliderRadius
      )
    ) {
      return targetPosition; // 충돌이 없으면 이동 가능
    }
    return currentPosition; // 충돌이 있으면 이동하지 않음
  }

  // 부채꼴 공격 범위 내의 모든 적 찾기
  static findEnemiesInSector(
    playerPosition,
    playerRotation,
    enemies,
    attackRange,
    attackAngle
  ) {
    const enemiesInRange = [];

    // 플레이어가 바라보는 방향 벡터
    const playerForward = new THREE.Vector3(
      Math.sin(playerRotation),
      0,
      Math.cos(playerRotation)
    ).normalize();

    for (const enemy of enemies) {
      if (enemy.isAliveCheck()) {
        const enemyPos = enemy.getPosition();
        const distance = playerPosition.distanceTo(enemyPos);

        // 거리 체크
        if (distance <= attackRange) {
          // 플레이어에서 적으로의 방향 벡터
          const toEnemy = new THREE.Vector3()
            .subVectors(enemyPos, playerPosition)
            .normalize();

          // 플레이어 전방과 적 방향의 각도 계산
          const angle = Math.acos(
            Math.max(-1, Math.min(1, playerForward.dot(toEnemy)))
          );

          // 부채꼴 중심각의 절반보다 작으면 공격 범위 내
          if (angle <= attackAngle / 2) {
            enemiesInRange.push(enemy);
          }
        }
      }
    }

    return enemiesInRange;
  }
}

// webpack 빌드를 위해 default export 추가
export default CollisionUtils;

// 전역 변수로도 등록 (기존 코드 호환성)
window.CollisionUtils = CollisionUtils;